module.exports = __webpack_public_path__ + "media/images/icon__community@3x-e4e38d480b2ce7c83ce636279171d075.png";